export const JOURNEYS = [
  {
    id: "forgiveness",
    title: "Forgiveness",
    subtitle: "Letting go and being set free",
    icon: "HeartHandshake",
    questions: [
      "What does the Bible say about forgiveness?",
      "Why did Jesus tell the parable of the prodigal son?",
      "How many times should I forgive someone?",
      "How did Joseph forgive his brothers?",
    ],
  },
  {
    id: "courage",
    title: "Courage",
    subtitle: "Facing fear with faith",
    icon: "Shield",
    questions: [
      "How did David find courage to face Goliath?",
      "What does the Bible say about fear?",
      "How was Daniel brave in the lions' den?",
      "Why did God tell Joshua to be strong and courageous?",
    ],
  },
  {
    id: "hope",
    title: "Hope",
    subtitle: "Light for the dark seasons",
    icon: "Sunrise",
    questions: [
      "What does the Bible say about hope?",
      "How did God comfort Job in his suffering?",
      "What is the hope of the resurrection?",
      "Why is Psalm 23 a comfort in hard times?",
    ],
  },
  {
    id: "love",
    title: "Love",
    subtitle: "The greatest of these",
    icon: "Heart",
    questions: [
      "What does love mean in 1 Corinthians 13?",
      "How did Jesus show the greatest love?",
      "What are the two greatest commandments?",
      "How can I love my neighbour as myself?",
    ],
  },
];
